var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group-buy-block',{staticClass:"group-buy-rule",attrs:{"title":"拼团须知"},scopedSlots:_vm._u([{key:"list",fn:function(){return [_c('div',{staticClass:"rule-list",domProps:{"innerHTML":_vm._s(_vm.rule)}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }